import gql from 'graphql-tag'

export const ADD_WISHLIST = gql`
  mutation($objects: [marketplace_user_wishlists_insert_input!]!) {
    insert_marketplace_user_wishlists(objects: $objects) {
      affected_rows
    }
  }
`
